<template>
    <wrapper-features-templates-one-column
	noWhiteBox
    nonAuthenticatedFeature
    thirdLevelMenu
	:customBreadcrumbs="{ currentArea: t('join.breadcrumbs.currentArea') }"
	@backOrCloseClicked="$emit('backOrCloseClicked')">
		<div class="buttons-cards-wrapper">
			<button-card
			v-for="menuEntry in getClientType === 'company' ? companyThirdLevelMenu : particularThirdLevelMenu"
			:key="`third-level-menu-${menuEntry.id}`"
			:icon="menuEntry.icon"
			:label="menuEntry.label"
			:description="menuEntry.description"
			@clicked="handleClick(menuEntry)"/>
		</div>
	</wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import ButtonCard from '@/components/generic/buttons/Card'
/* Vue & Helpers */
import { navigateByPath } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'

/* Store & mapGetters */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapGetters */
const { getClientType } = mapGetters()
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked'])

const particularThirdLevelMenu = [{
    label: t('join.createAccountTitle'),
    description: getMobileAppState.value ? t('join.createAccountDescriptionMobile') : t('join.createAccountDescriptionWeb'),
    icon: 'open-bank-account',
    link: routeList.NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_PATH
}, {
    label: t('join.joinBaiDirectTitle'),
    description: t('join.joinBaiDirectDescription'),
    icon: 'join-bai-direct',
    link: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_PATH
}]

const companyThirdLevelMenu = [{
    label: t('join.joinBaiDirectTitle'),
    description: t('join.joinBaiDirectDescription'),
    icon: 'join-bai-direct',
    link: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_PATH
}]

const handleClick = item => {
	navigateByPath(item.link)
}
</script>

<style lang="scss" scoped>
.feature-content-container {
	.one-column-wrapper {
		.buttons-cards-wrapper {
			height: auto;
			margin-top: 16px;

			display: flex;

			flex-direction: row;
			flex-wrap: wrap;
			align-content: flex-start;
			gap: 8px;

			.button-card {
				width: 100%;
			}
		}
	}

	&:not(.mobile) {
		.one-column-wrapper {
			padding: 0;
			background-color: transparent;

			.buttons-cards-wrapper {
				gap: 16px;

				.button-card {
					width: calc(50% - 8px);
				}
			}
		}
	}
}
</style>
